import InvoiceApi from '@/api/Invoice/api'

export default {
  methods: {
    async getInvoice (invoiceId) {
      if (!invoiceId) return {}
      try {
        const resp = await InvoiceApi.getInvoiceById(invoiceId)
        return resp.data
      } catch (e) {
        console.error(e)
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getInvoice.js